// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Removed unused types'
// Modified Date : 23-08-2025
const journalTransactionTypes = {
	/** ***************** FETCH JOURNAL TRANSACTION VOUCHER COUNT START *********************** */
	FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_START: 'fetch_journal_transaction_voucher_count_start',
	FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_SUCCESS:
		'fetch_journal_transaction_voucher_count_success',
	FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_FAILURE:
		'fetch_journal_transaction_voucher_count_failure',
	FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_RESET:
		'fetch_journal_transaction_voucher_response_reset',
	FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_CHANGED:
		'fetch_journal_transaction_voucher_response_changed',

	/** ***************** FETCH JOURNAL TRANSACTION VOUCHER COUNT END *********************** */

	/** ***************** FETCH PARTICULAR ACCOUNT DETAILS START *********************** */
	FETCH_PARTICULAR_ACCOUNT_DETAILS_START: 'fetch_particular_account_details_start',
	FETCH_PARTICULAR_ACCOUNT_DETAILS_SUCCESS: 'fetch_particular_account_details_success',
	FETCH_PARTICULAR_ACCOUNT_DETAILS_FAILURE: 'fetch_particular_account_details_failure',
	FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_CHANGED:
		'fetch_particular_account_details_response_changed',
	FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_RESET:
		'fetch_particular_account_details_response_reset',
	/** ***************** FETCH PARTICULAR ACCOUNT DETAILS END *********************** */

	/** ***************** CREATE JOURNAL ENTRY START *********************** */
	CREATE_JOURNAL_ENTRY_START: 'create_journal_entry_start',
	CREATE_JOURNAL_ENTRY_SUCCESS: 'create_journal_entry_success',
	CREATE_JOURNAL_ENTRY_FAILURE: 'create_journal_entry_failure',
	CREATE_JOURNAL_ENTRY_RESPONSE_CHANGED: 'create_journal_entry_response_changed',
	CREATE_JOURNAL_ENTRY_RESPONSE_RESET: 'create_journal_entry_response_reset',
	/** ***************** CREATE JOURNAL ENTRY END *********************** */

	/** ***************** UPDATE JOURNAL TRANSACTIONS ENTRY START *********************** */

	UPDATE_JOURNAL_ENTRY_START: 'update_journal_entry_start',
	UPDATE_JOURNAL_ENTRY_SUCCESS: 'update_journal_entry_success',
	UPDATE_JOURNAL_ENTRY_FAILURE: 'update_journal_entry_failure',
	UPDATE_JOURNAL_ENTRY_RESPONSE_CHANGED: 'update_journal_entry_response_changed',
	UPDATE_JOURNAL_ENTRY_RESPONSE_RESET: 'update_journal_entry_response_reset',

	/** ***************** UPDATE JOURNAL TRANSACTIONS ENTRY END *********************** */
};

export default journalTransactionTypes;
